module.exports = __webpack_public_path__ + "img/exc_symbol_mob.png";